import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "admin-table"
};
const _hoisted_2 = { class: "colored-row" };
const _hoisted_3 = { class: "w-16" };
const _hoisted_4 = ["aria-labelledby"];
const _hoisted_5 = ["id"];
const _hoisted_6 = { class: "text-left" };
const _hoisted_7 = { class: "block" };
const _hoisted_8 = ["href"];
const _hoisted_9 = { class: "font-medium" };
const _hoisted_10 = { class: "sr-only" };
const _hoisted_11 = { class: "my-loading" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_report_search = _resolveComponent("report-search");
    const _component_router_link = _resolveComponent("router-link");
    const _component_Loading = _resolveComponent("Loading");
    const _component_VueEternalLoading = _resolveComponent("VueEternalLoading");
    return (_openBlock(), _createElementBlock("div", null, [
        _cache[10] || (_cache[10] = _createElementVNode("div", {
            id: "campaigns",
            class: "flex"
        }, [
            _createElementVNode("h1", null, "Orders"),
            _createElementVNode("nav", null, "   ")
        ], -1)),
        _createVNode(_component_report_search, {
            searchFilters: ['reference', 'campaign', 'amount', 'name', 'email'],
            default: "campaign",
            onSearch: _ctx.search
        }, null, 8, ["onSearch"]),
        (_ctx.index.hasResults())
            ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                        _createElementVNode("div", null, [
                            _createElementVNode("table", null, [
                                _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
                                    _createElementVNode("tr", null, [
                                        _createElementVNode("th", { scope: "col" }, " "),
                                        _createElementVNode("th", { scope: "col" }, "Order Reference / Campaign"),
                                        _createElementVNode("th", { scope: "col" }, "Order Details"),
                                        _createElementVNode("th", { scope: "col" }, " "),
                                        _createElementVNode("th", { scope: "col" }, " "),
                                        _createElementVNode("th", { scope: "col" }, " ")
                                    ])
                                ], -1)),
                                _createElementVNode("tbody", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.index.getData(), (order) => {
                                        return (_openBlock(), _createElementBlock("tr", _hoisted_2, [
                                            _createElementVNode("td", _hoisted_3, [
                                                (_openBlock(), _createElementBlock("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    class: "h-10 w-10 text-slate-400 mx-auto",
                                                    fill: "none",
                                                    viewBox: "0 0 24 24",
                                                    stroke: "currentColor",
                                                    "stroke-width": "2",
                                                    role: "img",
                                                    focusable: "false",
                                                    "aria-labelledby": order.reference
                                                }, [...(_cache[1] || (_cache[1] = [
                                                        _createElementVNode("title", null, "Order", -1),
                                                        _createElementVNode("path", {
                                                            "stroke-linecap": "round",
                                                            "stroke-linejoin": "round",
                                                            d: "M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
                                                        }, null, -1)
                                                    ]))], 8, _hoisted_4))
                                            ]),
                                            _createElementVNode("td", null, [
                                                _createElementVNode("span", {
                                                    class: "block font-medium",
                                                    id: order.reference
                                                }, _toDisplayString(order.reference), 9, _hoisted_5),
                                                _createVNode(_component_router_link, {
                                                    to: { name: 'admin.campaign.manage', params: { account: order.account, slug: order.campaign } }
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(order.campaign_name), 1)
                                                    ]),
                                                    _: 2
                                                }, 1032, ["to"])
                                            ]),
                                            _createElementVNode("td", _hoisted_6, [
                                                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.f.formatCurrency(order.order_currency, order.order_total / 100)), 1),
                                                _createElementVNode("div", null, [
                                                    _createTextVNode(_toDisplayString(order.name) + " <", 1),
                                                    _createElementVNode("a", {
                                                        href: `mailto:${order.email}`,
                                                        target: "_blank"
                                                    }, _toDisplayString(order.email), 9, _hoisted_8),
                                                    _cache[2] || (_cache[2] = _createTextVNode(">", -1))
                                                ])
                                            ]),
                                            _createElementVNode("td", null, [
                                                _createElementVNode("span", {
                                                    class: _normalizeClass(["status-box with-ping", {
                                                            'status-open': order.status === 'open',
                                                            'status-processing': order.status === 'processing',
                                                            'status-complete': order.status === 'complete',
                                                            'status-cancelled': order.status === 'cancelled',
                                                        }])
                                                }, [
                                                    _createElementVNode("span", null, _toDisplayString(order.status), 1),
                                                    _cache[3] || (_cache[3] = _createElementVNode("span", null, [
                                                        _createElementVNode("span"),
                                                        _createElementVNode("span")
                                                    ], -1))
                                                ], 2)
                                            ]),
                                            _cache[5] || (_cache[5] = _createElementVNode("td", null, "   ", -1)),
                                            _createElementVNode("td", _hoisted_9, [
                                                _createVNode(_component_router_link, {
                                                    to: { name: 'admin.order.manage', params: { slug: order.reference } }
                                                }, {
                                                    default: _withCtx(() => [
                                                        _cache[4] || (_cache[4] = _createTextVNode(" Manage Order", -1)),
                                                        _createElementVNode("span", _hoisted_10, ", " + _toDisplayString(order.reference), 1)
                                                    ]),
                                                    _: 2
                                                }, 1032, ["to"])
                                            ])
                                        ]));
                                    }), 256))
                                ])
                            ])
                        ])
                    ])
                ])
            ]))
            : _createCommentVNode("", true),
        _createVNode(_component_VueEternalLoading, {
            load: _ctx.load,
            "is-initial": _ctx.isInitial,
            "onUpdate:isInitial": _cache[0] || (_cache[0] = ($event) => ((_ctx.isInitial) = $event))
        }, {
            loading: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_Loading, { message: "Loading Orders" })
                ])
            ]),
            "no-more": _withCtx(() => [...(_cache[7] || (_cache[7] = [
                    _createElementVNode("div", { class: "my-no-more" }, [
                        _createElementVNode("div", { class: "my-6 text-center" }, [
                            _createElementVNode("a", {
                                href: "#campaigns",
                                class: "flex justify-center"
                            }, [
                                _createElementVNode("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    class: "h-5 w-5 mr-2",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    stroke: "currentColor",
                                    "stroke-width": "2",
                                    focusable: "true"
                                }, [
                                    _createElementVNode("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        d: "M5 10l7-7m0 0l7 7m-7-7v18"
                                    })
                                ]),
                                _createTextVNode(" Top of Page ")
                            ])
                        ])
                    ], -1)
                ]))]),
            "no-results": _withCtx(() => [...(_cache[8] || (_cache[8] = [
                    _createElementVNode("div", { class: "no-results panel p-10 mt-4" }, [
                        _createElementVNode("div", { class: "text-slate-300 my-6" }, [
                            _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                class: "h-20 w-20 mx-auto",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor",
                                "stroke-width": "2"
                            }, [
                                _createElementVNode("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    d: "M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
                                })
                            ])
                        ]),
                        _createElementVNode("h2", { class: "text-slate-600 font-medium text-2xl text-center" }, "No Orders Available"),
                        _createElementVNode("p", { class: "text-center mt-4 text-sm text-slate-700" }, " We could not find any orders. ")
                    ], -1)
                ]))]),
            error: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                    _createElementVNode("div", { class: "no-results panel p-10 mt-4" }, [
                        _createElementVNode("div", { class: "text-slate-300 my-6" }, [
                            _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                class: "h-20 w-20 mx-auto",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                role: "img",
                                focusable: "false",
                                "aria-label": "An Error Occurred"
                            }, [
                                _createElementVNode("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                                })
                            ])
                        ]),
                        _createElementVNode("h2", { class: "text-slate-600 font-medium text-2xl text-center" }, "An Error Occurred"),
                        _createElementVNode("p", { class: "text-center mt-4 text-sm text-slate-700" }, " An error occurred, please try again. If this problem persists please contact support. ")
                    ], -1)
                ]))]),
            _: 1
        }, 8, ["load", "is-initial"])
    ]));
}
